/**
 * Master Data Edit (render)
 * Dropdown show/hide helpers.
 */

import { CommonUtils } from "../util/common-utils";
import { qs, qsa } from "./master-data-edit-form";

interface ProductCategoryTreeNode {
    id: number;
    name: string;
}

interface ProductCategoryTree {
    parents: ProductCategoryTreeNode[];
    children_by_parent: Record<string, ProductCategoryTreeNode[]>;
}

export class MasterDataEditRender {
    public static clearContainer(container: Element | null | undefined): void {
        CommonUtils.setHtml(container, "");
    }

    public static closeAllMasterMenus(): void {
        qsa(document, ".master-menu").forEach((menu) => {
            menu.style.display = "none";
        });
    }

    public static toggleMasterMenu(dropdown: HTMLElement): void {
        const menu = qs(dropdown, ".master-menu");
        if (!(menu instanceof HTMLElement)) return;

        const isOpen = menu.style.display === "block";
        if (isOpen) {
            menu.style.display = "none";
            return;
        }

        MasterDataEditRender.closeAllMasterMenus();
        menu.style.display = "block";
    }

    public static renderProductCategoryChildOptions(
        childSelect: HTMLSelectElement,
        tree: ProductCategoryTree,
        parentId: number | null,
        placeholderText: string,
        placeholderTranslate: string,
    ): void {
        if (!(childSelect instanceof HTMLSelectElement)) return;

        const safePlaceholderText = CommonUtils.escapeHtml(placeholderText || "Select category");
        const safeTranslate = CommonUtils.escapeHtml(placeholderTranslate || "select_category");

        let html = `<option value="" data-translate="${safeTranslate}">${safePlaceholderText}</option>`;

        if (parentId) {
            const parent = Array.isArray(tree?.parents)
                ? tree.parents.find((entry) => Number(entry?.id) === Number(parentId))
                : null;
            const parentLabel = parent ? `${parent.id}: ${parent.name}` : String(parentId);
            html += `<option value="${CommonUtils.escapeHtml(String(parentId))}">${CommonUtils.escapeHtml(parentLabel)}</option>`;

            const children = tree?.children_by_parent?.[String(parentId)] || [];
            html += children
                .map(
                    (child) =>
                        `<option value="${CommonUtils.escapeHtml(String(child.id))}">${CommonUtils.escapeHtml(`${child.id}: ${child.name}`)}</option>`,
                )
                .join("");
        }

        childSelect.innerHTML = html;
    }

    public static openUrlInNewTab(url: string): void {
        const safeHref = CommonUtils.escapeHtmlAttribute(String(url || ""));
        const anchorRole = `master-url-link-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const safeRole = CommonUtils.escapeHtmlAttribute(anchorRole);

        document.body.insertAdjacentHTML(
            "beforeend",
            `<a data-role="${safeRole}" href="${safeHref}" target="_blank" rel="noopener noreferrer" style="display:none"></a>`,
        );

        const anchor = qs(document.body, `[data-role="${safeRole}"]`);
        if (anchor instanceof HTMLAnchorElement) {
            anchor.click();
            anchor.remove();
        }
    }
}
